// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/requestcatalog/v1/requestcatalog.proto" (package "c1.api.requestcatalog.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { GrantReason } from "../../app/v1/app_entitlement_user_binding_reasons";
import { User } from "../../user/v1/user";
import { CatalogEntry } from "../../app/v1/app_entitlement";
import { AppResourceExpandMask } from "../../app/v1/app_resource";
import { AppResourceRef } from "../../app/v1/app_resource";
import { Facets } from "../../search/v1/facet";
import { AppResourceView } from "../../app/v1/app_resource";
import { AppEntitlementRef } from "../../app/v1/app_refs";
import { AppEntitlement } from "../../app/v1/app_entitlement";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Task } from "../../task/v1/task";
import { AppEntitlementUserView } from "../../app/v1/app_entitlement";
import { AppResourceType } from "../../app/v1/app_resource";
import { AppResource } from "../../app/v1/app_resource";
import { App } from "../../app/v1/app";
import { Any } from "../../../../google/protobuf/any";
import { AppEntitlementUserBinding } from "../../app/v1/app_entitlement_user_binding";
import { AppEntitlementView } from "../../app/v1/app_entitlement";
import { AppEntitlementExpandMask } from "../../app/v1/app_entitlement";
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceRequest
 */
export interface AccessRequestUrlManagerServiceRequest {
    /**
     * @generated from protobuf field: string token = 1
     */
    token: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceResponse
 */
export interface AccessRequestUrlManagerServiceResponse {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.AccessRequestQueryObject data = 1
     */
    data?: AccessRequestQueryObject;
    /**
     * @generated from protobuf field: int64 numeric_ticket_id = 2
     */
    numericTicketId: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateRequest
 */
export interface AccessRequestUrlManagerServiceGenerateRequest {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.AccessRequestQueryObject data = 1
     */
    data?: AccessRequestQueryObject;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateResponse
 */
export interface AccessRequestUrlManagerServiceGenerateResponse {
    /**
     * @generated from protobuf field: string token = 1
     */
    token: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessRequestQueryObject
 */
export interface AccessRequestQueryObject {
    /**
     * @generated from protobuf field: string userId = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: string appId = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlementId = 3
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: int64 grantDuration = 4
     */
    grantDuration: number;
    /**
     * @generated from protobuf field: string reason = 5
     */
    reason: string;
    /**
     * @generated from protobuf field: string externalUrl = 6
     */
    externalUrl: string;
    /**
     * @generated from protobuf field: string integrationId = 7
     */
    integrationId: string;
    /**
     * @generated from protobuf field: bool submit = 8
     */
    submit: boolean;
    /**
     * @generated from protobuf field: string requestId = 10
     */
    requestId: string;
    /**
     * @generated from protobuf field: repeated string entitlementIds = 11
     */
    entitlementIds: string[];
    /**
     * @generated from protobuf field: bool isEmergencyAccess = 12
     */
    isEmergencyAccess: boolean;
    /**
     * @generated from protobuf field: string appUserId = 13
     */
    appUserId: string;
}
/**
 * The RequestCatalogSearchServiceSearchEntitlementsRequest searches entitlements, but only ones that are available to you through the open catalogs.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest
 */
export interface RequestCatalogSearchServiceSearchEntitlementsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Fuzzy search the display name of resource types.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * Search for entitlements with this alias (exact match).
     *
     * @generated from protobuf field: string entitlement_alias = 4
     */
    entitlementAlias: string;
    /**
     * The expand mask descibes what paths to be expanded in the return value.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * Search entitlements with this granted status for your signed in user.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest.GrantedStatusFilter granted_status = 6
     */
    grantedStatus: RequestCatalogSearchServiceSearchEntitlementsRequest_GrantedStatusFilter;
    /**
     * Search entitlements that belong to this app name (exact match).
     *
     * @generated from protobuf field: string app_display_name = 7
     */
    appDisplayName: string;
    /**
     * Include deleted entitlements
     *
     * @generated from protobuf field: bool include_deleted = 8
     */
    includeDeleted: boolean;
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest.GrantedStatusFilter
 */
export enum RequestCatalogSearchServiceSearchEntitlementsRequest_GrantedStatusFilter {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Show entitlements that are both granted and not granted. Leaving this field blank will default to "ALL".
     *
     * @generated from protobuf enum value: ALL = 1;
     */
    ALL = 1,
    /**
     * Show entitlements that are granted.
     *
     * @generated from protobuf enum value: GRANTED = 2;
     */
    GRANTED = 2,
    /**
     * Show entitlements that are not granted.
     *
     * @generated from protobuf enum value: NOT_GRANTED = 3;
     */
    NOT_GRANTED = 3
}
/**
 * The AppEntitlementWithUserBindings message represents an app entitlement and its associated user bindings.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementWithUserBindings
 */
export interface AppEntitlementWithUserBindings {
    /**
     * The app entitlement that the user bindings are associated with.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1
     */
    entitlement?: AppEntitlementView;
    /**
     * An array of AppEntitlementUserBinding objects which represent the relationships that give app users access to the specific app entitlement.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBinding app_entitlement_user_bindings = 2
     */
    appEntitlementUserBindings: AppEntitlementUserBinding[];
}
/**
 * The RequestCatalogSearchServiceSearchEntitlementsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsResponse
 */
export interface RequestCatalogSearchServiceSearchEntitlementsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppEntitlementWithUserBindings list = 1
     */
    list: AppEntitlementWithUserBindings[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest
 */
export interface RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsRequest
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string catalog_ids = 6
     */
    catalogIds: string[];
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 7
     */
    grantEnrollmentStatus: GrantEnrollmentStatus;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus
 */
export interface BundleAppsWithGrantEnrollmentStatus {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 2
     */
    grantEnrollmentStatus: GrantEnrollmentStatus;
    /**
     * @generated from protobuf field: int32 app_entitlements_total = 3
     */
    appEntitlementsTotal: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleResponse
 */
export interface RequestCatalogSearchServiceListBrowsableAppsInBundleResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus list = 1
     */
    list: BundleAppsWithGrantEnrollmentStatus[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleRequest
 */
export interface RequestCatalogSearchServiceListBrowsableAppsInBundleRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string target_user_id = 3
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string catalog_id = 4
     */
    catalogId: string;
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef refs = 7
     */
    refs: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest
 */
export interface RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse
 */
export interface RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest {
    /**
     * @generated from protobuf field: string query = 1
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string target_user_id = 4
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: repeated string catalog_ids = 5
     */
    catalogIds: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 6
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef refs = 7
     */
    refs: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 4
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: bool exclude_credential_type = 5
     */
    excludeCredentialType: boolean;
    /**
     * @generated from protobuf field: int32 page_size = 6
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 7
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppResourceWithType list = 1
     */
    list: AppResourceWithType[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: int64 app_resource_count = 3
     */
    appResourceCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountRequest
 */
export interface RequestCatalogSearchServiceSearchAppResourcesCountRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 4
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: bool exclude_credential_type = 5
     */
    excludeCredentialType: boolean;
    /**
     * @generated from protobuf field: int32 page_size = 6
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 7
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppResourceCountsByResourceType
 */
export interface AppResourceCountsByResourceType {
    /**
     * @generated from protobuf field: string app_resource_type_id = 1
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: int64 resource_count = 2
     */
    resourceCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountResponse
 */
export interface RequestCatalogSearchServiceSearchAppResourcesCountResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppResourceCountsByResourceType list = 2
     */
    list: AppResourceCountsByResourceType[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppResourceWithType
 */
export interface AppResourceWithType {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource resource = 1
     */
    resource?: AppResource;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceType resource_type = 2
     */
    resourceType?: AppResourceType;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppWithGrantStatus
 */
export interface AppWithGrantStatus {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView binding = 2
     */
    binding?: AppEntitlementUserView;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BrowsableAppWithResourceCount
 */
export interface BrowsableAppWithResourceCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView binding = 2
     */
    binding?: AppEntitlementUserView;
    /**
     * @generated from protobuf field: int32 resource_count = 3
     */
    resourceCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse
 */
export interface RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppWithGrantStatus list = 1
     */
    list: AppWithGrantStatus[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsResponse
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.BrowsableAppWithResourceCount list = 1
     */
    list: BrowsableAppWithResourceCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.BundleAppsWithCount
 */
export interface BundleAppsWithCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1
     */
    app?: App;
    /**
     * @generated from protobuf field: int32 app_entitlements_granted = 2
     */
    appEntitlementsGranted: number;
    /**
     * @generated from protobuf field: int32 app_entitlements_total = 3
     */
    appEntitlementsTotal: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.BundleAppsWithCount list = 1
     */
    list: BundleAppsWithCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesRequest
 */
export interface RequestCatalogSearchServiceSearchTasksForResourcesRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string resource_ids = 5
     */
    resourceIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 6
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 7
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated string catalog_ids = 8
     */
    catalogIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef
 */
export interface RequestCatalogSearchServiceSearchEntitlementsPerAppRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2
     */
    entitlementId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchEntitlementsPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 4
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: int32 page_size = 5
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 6
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string resource_ids = 7
     */
    resourceIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 8
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 9
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef refs = 10
     */
    refs: RequestCatalogSearchServiceSearchEntitlementsPerAppRef[];
    /**
     * @generated from protobuf field: repeated string catalog_ids = 11
     */
    catalogIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchEntitlementsPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp list = 1
     */
    list: RequestCatalogUserEntitlementPerApp[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserRequest
 */
export interface RequestCatalogSearchServiceSearchEntitlementsForUserRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 5
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 6
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 7
     */
    grantEnrollmentStatus: GrantEnrollmentStatus;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserResponse
 */
export interface RequestCatalogSearchServiceSearchEntitlementsForUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp list = 1
     */
    list: RequestCatalogUserEntitlementPerApp[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesResponse
 */
export interface RequestCatalogSearchServiceSearchTasksForResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogResourceHasTask list = 1
     */
    list: RequestCatalogResourceHasTask[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp
 */
export interface RequestCatalogUserEntitlementPerApp {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2
     */
    appEntitlementUserBinding?: AppEntitlementUserView;
    /**
     * @generated from protobuf field: c1.api.task.v1.Task task = 3
     */
    task?: Task;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogResourceHasTask
 */
export interface RequestCatalogResourceHasTask {
    /**
     * @generated from protobuf field: string resource_id = 1
     */
    resourceId: string;
    /**
     * @generated from protobuf field: bool has_task = 2
     */
    hasTask: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp list = 1
     */
    list: RequestCatalogUserAccessEntitlementPerApp[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp
 */
export interface RequestCatalogUserAccessEntitlementPerApp {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2
     */
    appEntitlementUserBinding?: AppEntitlementUserView;
    /**
     * @generated from protobuf field: c1.api.task.v1.Task task = 3
     */
    task?: Task;
    /**
     * @generated from protobuf field: bool isRequestable = 4
     */
    isRequestable: boolean;
}
/**
 * The RequestCatalog is used for managing which entitlements are requestable, and who can request them.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalog
 */
export interface RequestCatalog {
    /**
     * The id of the request catalog.
     *
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * The display name of the request catalog.
     *
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * The description of the request catalog.
     *
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * The datetime, in RFC3339 format, of when the RequestCatalog was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the RequestCatalog was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the RequestCatalog was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 11
     */
    deletedAt?: Timestamp;
    /**
     * The id of the user this request catalog was created by.
     *
     * @generated from protobuf field: string created_by_user_id = 6
     */
    createdByUserId: string;
    /**
     * An array of app entitlements that, if the user has, can view the contents of this catalog.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlement access_entitlements = 8
     */
    accessEntitlements: AppEntitlement[];
    /**
     * If this is true, the access entitlement requirement is ignored.
     *
     * @generated from protobuf field: bool visible_to_everyone = 9
     */
    visibleToEveryone: boolean;
    /**
     * Whether or not this catalog is published.
     *
     * @generated from protobuf field: bool published = 10
     */
    published: boolean;
    /**
     * Whether all the entitlements in the catalog can be requests at once. Your tenant must have the bundles feature to use this.
     *
     * @generated from protobuf field: bool request_bundle = 12
     */
    requestBundle: boolean;
    /**
     * Defines how to handle the request policies of the entitlements in the catalog during enrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior enrollment_behavior = 13
     */
    enrollmentBehavior: RequestCatalogEnrollmentBehavior;
    /**
     * Defines how to handle the revocation of the entitlements in the catalog during unenrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior unenrollment_behavior = 14
     */
    unenrollmentBehavior: RequestCatalogUnenrollmentBehavior;
    /**
     * Defines how to handle the revoke policies of the entitlements in the catalog during unenrollment.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior unenrollment_entitlement_behavior = 15
     */
    unenrollmentEntitlementBehavior: RequestCatalogUnenrollmentEntitlementBehavior;
}
/**
 * The request catalog view contains the serialized request catalog and paths to objects referenced by the request catalog.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogView
 */
export interface RequestCatalogView {
    /**
     * The serialized request catalog.
     *
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalog request_catalog = 1
     */
    requestCatalog?: RequestCatalog;
    /**
     * JSONPATH expression indicating the location of the User object, that created the request catalog, in the array.
     *
     * @generated from protobuf field: string created_by_user_path = 2
     */
    createdByUserPath: string;
    /**
     * JSONPATH expression indicating the location of the access entitlement objects, that the request catalog allows users to request, in the array.
     *
     * @generated from protobuf field: string access_entitlements_path = 4
     */
    accessEntitlementsPath: string;
    /**
     * Total number of the members of the catalog
     *
     * @generated from protobuf field: int64 member_count = 5
     */
    memberCount: number;
}
/**
 * The RequestCatalogExpandMask includes the paths in the catalog view to expand in the return value of this call.
 *
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogExpandMask
 */
export interface RequestCatalogExpandMask {
    /**
     * An array of paths to be expanded in the response. May be any combination of "*", "created_by_user_id", "app_ids", and "access_entitlements".
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchResourceTypesPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6
     */
    resourceTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount
 */
export interface ResourceTypeWithEntitlementCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceType resource = 1
     */
    resource?: AppResourceType;
    /**
     * @generated from protobuf field: int64 count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchResourceTypesPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount list = 1
     */
    list: ResourceTypeWithEntitlementCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CatalogRef
 */
export interface CatalogRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsRequest
 */
export interface SearchRequestCatalogsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 4
     */
    appEntitlements: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.CatalogRef refs = 5
     */
    refs: CatalogRef[];
    /**
     * @generated from protobuf field: bool include_app_catalogs = 6
     */
    includeAppCatalogs: boolean;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsResponse
 */
export interface SearchRequestCatalogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalog list = 1
     */
    list: RequestCatalog[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsRequest
 */
export interface SearchRequestCatalogsWithEnrollmentCountsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 4
     */
    appEntitlements: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.CatalogRef refs = 5
     */
    refs: CatalogRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsResponse
 */
export interface SearchRequestCatalogsWithEnrollmentCountsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView list = 1
     */
    list: RequestCatalogWithEnrollmentCountView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView
 */
export interface RequestCatalogWithEnrollmentCountView {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.RequestCatalog request_catalog = 1
     */
    requestCatalog?: RequestCatalog;
    /**
     * @generated from protobuf field: int64 count = 2
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogsRef
 */
export interface AppEntitlementWithRequestCatalogsRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs
 */
export interface AppEntitlementWithRequestCatalogs {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 1
     */
    entitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource app_resource = 2
     */
    appResource?: AppResource;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceType app_resource_type = 3
     */
    appResourceType?: AppResourceType;
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalog catalogs = 4
     */
    catalogs: RequestCatalog[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest
 */
export interface SearchAppEntitlementsWithRequestCatalogsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 5
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 6
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: string alias = 7
     */
    alias: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 8
     */
    refs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsResponse
 */
export interface SearchAppEntitlementsWithRequestCatalogsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs list = 1
     */
    list: AppEntitlementWithRequestCatalogs[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsRequest
 */
export interface GetAppEntitlementWithRequestCatalogsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsResponse
 */
export interface GetAppEntitlementWithRequestCatalogsResponse {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs entitlement = 1
     */
    entitlement?: AppEntitlementWithRequestCatalogs;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppRequest
 */
export interface RequestCatalogSearchServiceSearchResourcesPerAppRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: int32 page_size = 4
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated string resource_ids = 6
     */
    resourceIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.ResourceWithEntitlementCount
 */
export interface ResourceWithEntitlementCount {
    /**
     * @generated from protobuf field: int64 count = 2
     */
    count: number;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceView item = 3
     */
    item?: AppResourceView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 4
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppResponse
 */
export interface RequestCatalogSearchServiceSearchResourcesPerAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.ResourceWithEntitlementCount list = 1
     */
    list: ResourceWithEntitlementCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsResponse
 */
export interface AppEntitlementsInCatalogTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest
 */
export interface AppEntitlementsInCatalogTermsRequest {
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest search = 1
     */
    search?: SearchAppEntitlementsInCatalogRequest;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest.TermType term = 2
     */
    term: AppEntitlementsInCatalogTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest.TermType
 */
export enum AppEntitlementsInCatalogTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APPLICATION_IDS = 1;
     */
    APPLICATION_IDS = 1,
    /**
     * @generated from protobuf enum value: RESOURCE_TYPE_IDS = 2;
     */
    RESOURCE_TYPE_IDS = 2
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRemovedUsersRequest
 */
export interface SearchRemovedUsersRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppResourcesInCatalogRequest
 */
export interface SearchAppResourcesInCatalogRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRef refs = 5
     */
    refs: AppResourceRef[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceExpandMask expand_mask = 6
     */
    expandMask?: AppResourceExpandMask;
    /**
     * @generated from protobuf field: repeated string app_ids = 7
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CountUsersLosingMembershipRequest
 */
export interface CountUsersLosingMembershipRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.CountUsersLosingMembershipResponse
 */
export interface CountUsersLosingMembershipResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest
 */
export interface SearchAppEntitlementsInCatalogRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5
     */
    appIds: string[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef refs = 7
     */
    refs: RequestCatalogAppEntitlementBindingRef[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 8
     */
    resourceTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogResponse
 */
export interface SearchAppEntitlementsInCatalogResponse {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.CatalogEntry list = 4
     */
    list: CatalogEntry[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRemovedUsersResponse
 */
export interface SearchRemovedUsersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchAppResourcesInCatalogResponse
 */
export interface SearchAppResourcesInCatalogResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceView list = 1
     */
    list: AppResourceView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogBundlesRequest
 */
export interface SearchRequestCatalogBundlesRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_enrollment_disabled = 5
     */
    includeEnrollmentDisabled: boolean;
    /**
     * @generated from protobuf field: c1.api.requestcatalog.v1.GrantEnrollmentStatus enrollment_status = 6
     */
    enrollmentStatus: GrantEnrollmentStatus;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogBundlesResponse
 */
export interface SearchRequestCatalogBundlesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.RequestCatalog list = 1
     */
    list: RequestCatalog[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef
 */
export interface RequestCatalogAppEntitlementBindingRef {
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 3
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessProfileMembershipRequest
 */
export interface AccessProfileMembershipRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string access_profile_id = 3
     */
    accessProfileId: string;
    /**
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessProfileMembershipResponse
 */
export interface AccessProfileMembershipResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AccessProfileMembership list = 1
     */
    list: AccessProfileMembership[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AccessProfileMembership
 */
export interface AccessProfileMembership {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement access_profile = 1
     */
    accessProfile?: AppEntitlement;
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 2
     */
    user?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp added_at = 3
     */
    addedAt?: Timestamp;
    /**
     * How the user was added (manual, automation, etc.)
     *
     * @generated from protobuf field: repeated c1.api.app.v1.GrantReason added_via = 4
     */
    addedVia: GrantReason[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string target_user_id = 2
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 4
     */
    resourceTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType
 */
export interface AppResourceWithEntitlementCountType {
    /**
     * @generated from protobuf field: string app_resource_type_id = 1
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: int64 app_entitlement_count = 2
     */
    appEntitlementCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse
 */
export interface RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType list = 1
     */
    list: AppResourceWithEntitlementCountType[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppRequest
 */
export interface RequestCatalogSearchServiceEntitlementCountByAppRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: string query = 2
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 3
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 4
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest
 */
export interface RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1
     */
    catalogId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 4
     */
    refs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse
 */
export interface RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.AppWithEntitlementCountType
 */
export interface AppWithEntitlementCountType {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int64 entitlement_count = 2
     */
    entitlementCount: number;
}
/**
 * @generated from protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppResponse
 */
export interface RequestCatalogSearchServiceEntitlementCountByAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.requestcatalog.v1.AppWithEntitlementCountType list = 1
     */
    list: AppWithEntitlementCountType[];
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.GrantEnrollmentStatus
 */
export enum GrantEnrollmentStatus {
    /**
     * @generated from protobuf enum value: GRANT_ENROLLMENT_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_ENROLLMENT_STATUS_FULLY_GRANTED = 1;
     */
    FULLY_GRANTED = 1,
    /**
     * @generated from protobuf enum value: GRANT_ENROLLMENT_STATUS_NOT_GRANTED = 2;
     */
    NOT_GRANTED = 2,
    /**
     * @generated from protobuf enum value: GRANT_ENROLLMENT_STATUS_PARTIALLY_GRANTED = 3;
     */
    PARTIALLY_GRANTED = 3
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogType
 */
export enum RequestCatalogType {
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_TYPE_CATALOG = 1;
     */
    CATALOG = 1,
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_TYPE_PROFILE = 2;
     */
    PROFILE = 2
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior
 */
export enum RequestCatalogEnrollmentBehavior {
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The request policies on the catalog's entitlements are ignored, and the grants will be auto-approved.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_BYPASS_ENTITLEMENT_REQUEST_POLICY = 1;
     */
    BYPASS_ENTITLEMENT_REQUEST_POLICY = 1,
    /**
     * The request policies on the catalog's entitlements are honored.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_ENFORCE_ENTITLEMENT_REQUEST_POLICY = 2;
     */
    ENFORCE_ENTITLEMENT_REQUEST_POLICY = 2
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior
 */
export enum RequestCatalogUnenrollmentBehavior {
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Do not create tickets to revoke entitlements when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_LEAVE_ACCESS_AS_IS = 1;
     */
    LEAVE_ACCESS_AS_IS = 1,
    /**
     * Revoke all entitlements within the catalog when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_REVOKE_ALL = 2;
     */
    REVOKE_ALL = 2,
    /**
     * Revoke all entitlements within the catalog that were granted without a justification (based on grant reasons) when a user is unenrolled from the catalog.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_REVOKE_UNJUSTIFIED = 3;
     */
    REVOKE_UNJUSTIFIED = 3
}
/**
 * @generated from protobuf enum c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior
 */
export enum RequestCatalogUnenrollmentEntitlementBehavior {
    /**
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The revoke policies on the catalog's entitlements are ignored, and the revocations will be auto-approved.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_BYPASS = 1;
     */
    BYPASS = 1,
    /**
     * The revoke policies on the catalog's entitlements are honored.
     *
     * @generated from protobuf enum value: REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_ENFORCE = 2;
     */
    ENFORCE = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestUrlManagerServiceRequest$Type extends MessageType<AccessRequestUrlManagerServiceRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceRequest", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessRequestUrlManagerServiceRequest>): AccessRequestUrlManagerServiceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial<AccessRequestUrlManagerServiceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessRequestUrlManagerServiceRequest): AccessRequestUrlManagerServiceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessRequestUrlManagerServiceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceRequest
 */
export const AccessRequestUrlManagerServiceRequest = new AccessRequestUrlManagerServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestUrlManagerServiceResponse$Type extends MessageType<AccessRequestUrlManagerServiceResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceResponse", [
            { no: 1, name: "data", kind: "message", T: () => AccessRequestQueryObject },
            { no: 2, name: "numeric_ticket_id", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AccessRequestUrlManagerServiceResponse>): AccessRequestUrlManagerServiceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.numericTicketId = 0;
        if (value !== undefined)
            reflectionMergePartial<AccessRequestUrlManagerServiceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessRequestUrlManagerServiceResponse): AccessRequestUrlManagerServiceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.AccessRequestQueryObject data */ 1:
                    message.data = AccessRequestQueryObject.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                case /* int64 numeric_ticket_id */ 2:
                    message.numericTicketId = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessRequestUrlManagerServiceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.AccessRequestQueryObject data = 1; */
        if (message.data)
            AccessRequestQueryObject.internalBinaryWrite(message.data, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 numeric_ticket_id = 2; */
        if (message.numericTicketId !== 0)
            writer.tag(2, WireType.Varint).int64(message.numericTicketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceResponse
 */
export const AccessRequestUrlManagerServiceResponse = new AccessRequestUrlManagerServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestUrlManagerServiceGenerateRequest$Type extends MessageType<AccessRequestUrlManagerServiceGenerateRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateRequest", [
            { no: 1, name: "data", kind: "message", T: () => AccessRequestQueryObject }
        ]);
    }
    create(value?: PartialMessage<AccessRequestUrlManagerServiceGenerateRequest>): AccessRequestUrlManagerServiceGenerateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AccessRequestUrlManagerServiceGenerateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessRequestUrlManagerServiceGenerateRequest): AccessRequestUrlManagerServiceGenerateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.AccessRequestQueryObject data */ 1:
                    message.data = AccessRequestQueryObject.internalBinaryRead(reader, reader.uint32(), options, message.data);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessRequestUrlManagerServiceGenerateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.AccessRequestQueryObject data = 1; */
        if (message.data)
            AccessRequestQueryObject.internalBinaryWrite(message.data, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateRequest
 */
export const AccessRequestUrlManagerServiceGenerateRequest = new AccessRequestUrlManagerServiceGenerateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestUrlManagerServiceGenerateResponse$Type extends MessageType<AccessRequestUrlManagerServiceGenerateResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateResponse", [
            { no: 1, name: "token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AccessRequestUrlManagerServiceGenerateResponse>): AccessRequestUrlManagerServiceGenerateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.token = "";
        if (value !== undefined)
            reflectionMergePartial<AccessRequestUrlManagerServiceGenerateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessRequestUrlManagerServiceGenerateResponse): AccessRequestUrlManagerServiceGenerateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string token */ 1:
                    message.token = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessRequestUrlManagerServiceGenerateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string token = 1; */
        if (message.token !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.token);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestUrlManagerServiceGenerateResponse
 */
export const AccessRequestUrlManagerServiceGenerateResponse = new AccessRequestUrlManagerServiceGenerateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessRequestQueryObject$Type extends MessageType<AccessRequestQueryObject> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessRequestQueryObject", [
            { no: 1, name: "userId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "appId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "entitlementId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "grantDuration", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "externalUrl", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "integrationId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "submit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "requestId", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "entitlementIds", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 12, name: "isEmergencyAccess", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "appUserId", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessRequestQueryObject>): AccessRequestQueryObject {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.appId = "";
        message.entitlementId = "";
        message.grantDuration = 0;
        message.reason = "";
        message.externalUrl = "";
        message.integrationId = "";
        message.submit = false;
        message.requestId = "";
        message.entitlementIds = [];
        message.isEmergencyAccess = false;
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessRequestQueryObject>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessRequestQueryObject): AccessRequestQueryObject {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string userId */ 1:
                    message.userId = reader.string();
                    break;
                case /* string appId */ 2:
                    message.appId = reader.string();
                    break;
                case /* string entitlementId */ 3:
                    message.entitlementId = reader.string();
                    break;
                case /* int64 grantDuration */ 4:
                    message.grantDuration = reader.int64().toNumber();
                    break;
                case /* string reason */ 5:
                    message.reason = reader.string();
                    break;
                case /* string externalUrl */ 6:
                    message.externalUrl = reader.string();
                    break;
                case /* string integrationId */ 7:
                    message.integrationId = reader.string();
                    break;
                case /* bool submit */ 8:
                    message.submit = reader.bool();
                    break;
                case /* string requestId */ 10:
                    message.requestId = reader.string();
                    break;
                case /* repeated string entitlementIds */ 11:
                    message.entitlementIds.push(reader.string());
                    break;
                case /* bool isEmergencyAccess */ 12:
                    message.isEmergencyAccess = reader.bool();
                    break;
                case /* string appUserId */ 13:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessRequestQueryObject, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string userId = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string appId = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string entitlementId = 3; */
        if (message.entitlementId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementId);
        /* int64 grantDuration = 4; */
        if (message.grantDuration !== 0)
            writer.tag(4, WireType.Varint).int64(message.grantDuration);
        /* string reason = 5; */
        if (message.reason !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reason);
        /* string externalUrl = 6; */
        if (message.externalUrl !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.externalUrl);
        /* string integrationId = 7; */
        if (message.integrationId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.integrationId);
        /* bool submit = 8; */
        if (message.submit !== false)
            writer.tag(8, WireType.Varint).bool(message.submit);
        /* string requestId = 10; */
        if (message.requestId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.requestId);
        /* repeated string entitlementIds = 11; */
        for (let i = 0; i < message.entitlementIds.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.entitlementIds[i]);
        /* bool isEmergencyAccess = 12; */
        if (message.isEmergencyAccess !== false)
            writer.tag(12, WireType.Varint).bool(message.isEmergencyAccess);
        /* string appUserId = 13; */
        if (message.appUserId !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessRequestQueryObject
 */
export const AccessRequestQueryObject = new AccessRequestQueryObject$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsRequest$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "entitlement_alias", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z0-9][-a-z0-9_.]{0,61}[a-z0-9]$", ignoreEmpty: true } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 6, name: "granted_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest.GrantedStatusFilter", RequestCatalogSearchServiceSearchEntitlementsRequest_GrantedStatusFilter], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 7, name: "app_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 8, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchEntitlementsRequest>): RequestCatalogSearchServiceSearchEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.entitlementAlias = "";
        message.grantedStatus = 0;
        message.appDisplayName = "";
        message.includeDeleted = false;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchEntitlementsRequest): RequestCatalogSearchServiceSearchEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* string entitlement_alias */ 4:
                    message.entitlementAlias = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest.GrantedStatusFilter granted_status */ 6:
                    message.grantedStatus = reader.int32();
                    break;
                case /* string app_display_name */ 7:
                    message.appDisplayName = reader.string();
                    break;
                case /* bool include_deleted */ 8:
                    message.includeDeleted = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* string entitlement_alias = 4; */
        if (message.entitlementAlias !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.entitlementAlias);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest.GrantedStatusFilter granted_status = 6; */
        if (message.grantedStatus !== 0)
            writer.tag(6, WireType.Varint).int32(message.grantedStatus);
        /* string app_display_name = 7; */
        if (message.appDisplayName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.appDisplayName);
        /* bool include_deleted = 8; */
        if (message.includeDeleted !== false)
            writer.tag(8, WireType.Varint).bool(message.includeDeleted);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsRequest
 */
export const RequestCatalogSearchServiceSearchEntitlementsRequest = new RequestCatalogSearchServiceSearchEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithUserBindings$Type extends MessageType<AppEntitlementWithUserBindings> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementWithUserBindings", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "app_entitlement_user_bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBinding }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementWithUserBindings>): AppEntitlementWithUserBindings {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementUserBindings = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementWithUserBindings>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementWithUserBindings): AppEntitlementWithUserBindings {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView entitlement */ 1:
                    message.entitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementUserBinding app_entitlement_user_bindings */ 2:
                    message.appEntitlementUserBindings.push(AppEntitlementUserBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementWithUserBindings, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView entitlement = 1; */
        if (message.entitlement)
            AppEntitlementView.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementUserBinding app_entitlement_user_bindings = 2; */
        for (let i = 0; i < message.appEntitlementUserBindings.length; i++)
            AppEntitlementUserBinding.internalBinaryWrite(message.appEntitlementUserBindings[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementWithUserBindings
 */
export const AppEntitlementWithUserBindings = new AppEntitlementWithUserBindings$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsResponse$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithUserBindings },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchEntitlementsResponse>): RequestCatalogSearchServiceSearchEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchEntitlementsResponse): RequestCatalogSearchServiceSearchEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.AppEntitlementWithUserBindings list */ 1:
                    message.list.push(AppEntitlementWithUserBindings.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.AppEntitlementWithUserBindings list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithUserBindings.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsResponse
 */
export const RequestCatalogSearchServiceSearchEntitlementsResponse = new RequestCatalogSearchServiceSearchEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest$Type extends MessageType<RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest>): RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest): RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest
 */
export const RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest = new RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsRequest$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "grant_enrollment_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.GrantEnrollmentStatus", GrantEnrollmentStatus, "GRANT_ENROLLMENT_STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppsRequest>): RequestCatalogSearchServiceSearchBrowsableAppsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appIds = [];
        message.catalogIds = [];
        message.grantEnrollmentStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppsRequest): RequestCatalogSearchServiceSearchBrowsableAppsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated string catalog_ids */ 6:
                    message.catalogIds.push(reader.string());
                    break;
                case /* c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status */ 7:
                    message.grantEnrollmentStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated string catalog_ids = 6; */
        for (let i = 0; i < message.catalogIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.catalogIds[i]);
        /* c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 7; */
        if (message.grantEnrollmentStatus !== 0)
            writer.tag(7, WireType.Varint).int32(message.grantEnrollmentStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsRequest
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsRequest = new RequestCatalogSearchServiceSearchBrowsableAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef>): RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef): RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef = new RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAppsWithGrantEnrollmentStatus$Type extends MessageType<BundleAppsWithGrantEnrollmentStatus> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "grant_enrollment_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.GrantEnrollmentStatus", GrantEnrollmentStatus, "GRANT_ENROLLMENT_STATUS_"] },
            { no: 3, name: "app_entitlements_total", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<BundleAppsWithGrantEnrollmentStatus>): BundleAppsWithGrantEnrollmentStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.grantEnrollmentStatus = 0;
        message.appEntitlementsTotal = 0;
        if (value !== undefined)
            reflectionMergePartial<BundleAppsWithGrantEnrollmentStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BundleAppsWithGrantEnrollmentStatus): BundleAppsWithGrantEnrollmentStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status */ 2:
                    message.grantEnrollmentStatus = reader.int32();
                    break;
                case /* int32 app_entitlements_total */ 3:
                    message.appEntitlementsTotal = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BundleAppsWithGrantEnrollmentStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 2; */
        if (message.grantEnrollmentStatus !== 0)
            writer.tag(2, WireType.Varint).int32(message.grantEnrollmentStatus);
        /* int32 app_entitlements_total = 3; */
        if (message.appEntitlementsTotal !== 0)
            writer.tag(3, WireType.Varint).int32(message.appEntitlementsTotal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus
 */
export const BundleAppsWithGrantEnrollmentStatus = new BundleAppsWithGrantEnrollmentStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceListBrowsableAppsInBundleResponse$Type extends MessageType<RequestCatalogSearchServiceListBrowsableAppsInBundleResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BundleAppsWithGrantEnrollmentStatus },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceListBrowsableAppsInBundleResponse>): RequestCatalogSearchServiceListBrowsableAppsInBundleResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceListBrowsableAppsInBundleResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceListBrowsableAppsInBundleResponse): RequestCatalogSearchServiceListBrowsableAppsInBundleResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus list */ 1:
                    message.list.push(BundleAppsWithGrantEnrollmentStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceListBrowsableAppsInBundleResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.BundleAppsWithGrantEnrollmentStatus list = 1; */
        for (let i = 0; i < message.list.length; i++)
            BundleAppsWithGrantEnrollmentStatus.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleResponse
 */
export const RequestCatalogSearchServiceListBrowsableAppsInBundleResponse = new RequestCatalogSearchServiceListBrowsableAppsInBundleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceListBrowsableAppsInBundleRequest$Type extends MessageType<RequestCatalogSearchServiceListBrowsableAppsInBundleRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceListBrowsableAppsInBundleRequest>): RequestCatalogSearchServiceListBrowsableAppsInBundleRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.targetUserId = "";
        message.catalogId = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceListBrowsableAppsInBundleRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceListBrowsableAppsInBundleRequest): RequestCatalogSearchServiceListBrowsableAppsInBundleRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string target_user_id */ 3:
                    message.targetUserId = reader.string();
                    break;
                case /* string catalog_id */ 4:
                    message.catalogId = reader.string();
                    break;
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef refs */ 7:
                    message.refs.push(RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceListBrowsableAppsInBundleRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string target_user_id = 3; */
        if (message.targetUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.targetUserId);
        /* string catalog_id = 4; */
        if (message.catalogId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.catalogId);
        /* repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef refs = 7; */
        for (let i = 0; i < message.refs.length; i++)
            RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef.internalBinaryWrite(message.refs[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceListBrowsableAppsInBundleRequest
 */
export const RequestCatalogSearchServiceListBrowsableAppsInBundleRequest = new RequestCatalogSearchServiceListBrowsableAppsInBundleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest>): RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest): RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest
 */
export const RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest = new RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse>): RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse): RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse
 */
export const RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse = new RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest>): RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.targetUserId = "";
        message.catalogIds = [];
        message.appIds = [];
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest): RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string query */ 1:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string target_user_id */ 4:
                    message.targetUserId = reader.string();
                    break;
                case /* repeated string catalog_ids */ 5:
                    message.catalogIds.push(reader.string());
                    break;
                case /* repeated string app_ids */ 6:
                    message.appIds.push(reader.string());
                    break;
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef refs */ 7:
                    message.refs.push(RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string query = 1; */
        if (message.query !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string target_user_id = 4; */
        if (message.targetUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.targetUserId);
        /* repeated string catalog_ids = 5; */
        for (let i = 0; i < message.catalogIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.catalogIds[i]);
        /* repeated string app_ids = 6; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.appIds[i]);
        /* repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef refs = 7; */
        for (let i = 0; i < message.refs.length; i++)
            RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef.internalBinaryWrite(message.refs[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest = new RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "exclude_credential_type", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 7, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest>): RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.query = "";
        message.resourceTypeIds = [];
        message.excludeCredentialType = false;
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest): RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string resource_type_ids */ 4:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* bool exclude_credential_type */ 5:
                    message.excludeCredentialType = reader.bool();
                    break;
                case /* int32 page_size */ 6:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 7:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string resource_type_ids = 4; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* bool exclude_credential_type = 5; */
        if (message.excludeCredentialType !== false)
            writer.tag(5, WireType.Varint).bool(message.excludeCredentialType);
        /* int32 page_size = 6; */
        if (message.pageSize !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageSize);
        /* string page_token = 7; */
        if (message.pageToken !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest
 */
export const RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest = new RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceWithType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse>): RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.appResourceCount = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse): RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.AppResourceWithType list */ 1:
                    message.list.push(AppResourceWithType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* int64 app_resource_count */ 3:
                    message.appResourceCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.AppResourceWithType list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppResourceWithType.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* int64 app_resource_count = 3; */
        if (message.appResourceCount !== 0)
            writer.tag(3, WireType.Varint).int64(message.appResourceCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse
 */
export const RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse = new RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAppResourcesCountRequest$Type extends MessageType<RequestCatalogSearchServiceSearchAppResourcesCountRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "exclude_credential_type", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 7, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchAppResourcesCountRequest>): RequestCatalogSearchServiceSearchAppResourcesCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.query = "";
        message.resourceTypeIds = [];
        message.excludeCredentialType = false;
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchAppResourcesCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchAppResourcesCountRequest): RequestCatalogSearchServiceSearchAppResourcesCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string resource_type_ids */ 4:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* bool exclude_credential_type */ 5:
                    message.excludeCredentialType = reader.bool();
                    break;
                case /* int32 page_size */ 6:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 7:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchAppResourcesCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string resource_type_ids = 4; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* bool exclude_credential_type = 5; */
        if (message.excludeCredentialType !== false)
            writer.tag(5, WireType.Varint).bool(message.excludeCredentialType);
        /* int32 page_size = 6; */
        if (message.pageSize !== 0)
            writer.tag(6, WireType.Varint).int32(message.pageSize);
        /* string page_token = 7; */
        if (message.pageToken !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountRequest
 */
export const RequestCatalogSearchServiceSearchAppResourcesCountRequest = new RequestCatalogSearchServiceSearchAppResourcesCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceCountsByResourceType$Type extends MessageType<AppResourceCountsByResourceType> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppResourceCountsByResourceType", [
            { no: 1, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppResourceCountsByResourceType>): AppResourceCountsByResourceType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appResourceTypeId = "";
        message.resourceCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppResourceCountsByResourceType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppResourceCountsByResourceType): AppResourceCountsByResourceType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_resource_type_id */ 1:
                    message.appResourceTypeId = reader.string();
                    break;
                case /* int64 resource_count */ 2:
                    message.resourceCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppResourceCountsByResourceType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_resource_type_id = 1; */
        if (message.appResourceTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appResourceTypeId);
        /* int64 resource_count = 2; */
        if (message.resourceCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.resourceCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppResourceCountsByResourceType
 */
export const AppResourceCountsByResourceType = new AppResourceCountsByResourceType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAppResourcesCountResponse$Type extends MessageType<RequestCatalogSearchServiceSearchAppResourcesCountResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountResponse", [
            { no: 2, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceCountsByResourceType },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchAppResourcesCountResponse>): RequestCatalogSearchServiceSearchAppResourcesCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchAppResourcesCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchAppResourcesCountResponse): RequestCatalogSearchServiceSearchAppResourcesCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.AppResourceCountsByResourceType list */ 2:
                    message.list.push(AppResourceCountsByResourceType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchAppResourcesCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.AppResourceCountsByResourceType list = 2; */
        for (let i = 0; i < message.list.length; i++)
            AppResourceCountsByResourceType.internalBinaryWrite(message.list[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppResourcesCountResponse
 */
export const RequestCatalogSearchServiceSearchAppResourcesCountResponse = new RequestCatalogSearchServiceSearchAppResourcesCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceWithType$Type extends MessageType<AppResourceWithType> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppResourceWithType", [
            { no: 1, name: "resource", kind: "message", T: () => AppResource },
            { no: 2, name: "resource_type", kind: "message", T: () => AppResourceType }
        ]);
    }
    create(value?: PartialMessage<AppResourceWithType>): AppResourceWithType {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppResourceWithType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppResourceWithType): AppResourceWithType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppResource resource */ 1:
                    message.resource = AppResource.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                case /* c1.api.app.v1.AppResourceType resource_type */ 2:
                    message.resourceType = AppResourceType.internalBinaryRead(reader, reader.uint32(), options, message.resourceType);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppResourceWithType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppResource resource = 1; */
        if (message.resource)
            AppResource.internalBinaryWrite(message.resource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppResourceType resource_type = 2; */
        if (message.resourceType)
            AppResourceType.internalBinaryWrite(message.resourceType, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppResourceWithType
 */
export const AppResourceWithType = new AppResourceWithType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithGrantStatus$Type extends MessageType<AppWithGrantStatus> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppWithGrantStatus", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "binding", kind: "message", T: () => AppEntitlementUserView }
        ]);
    }
    create(value?: PartialMessage<AppWithGrantStatus>): AppWithGrantStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppWithGrantStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppWithGrantStatus): AppWithGrantStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* c1.api.app.v1.AppEntitlementUserView binding */ 2:
                    message.binding = AppEntitlementUserView.internalBinaryRead(reader, reader.uint32(), options, message.binding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppWithGrantStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementUserView binding = 2; */
        if (message.binding)
            AppEntitlementUserView.internalBinaryWrite(message.binding, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppWithGrantStatus
 */
export const AppWithGrantStatus = new AppWithGrantStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BrowsableAppWithResourceCount$Type extends MessageType<BrowsableAppWithResourceCount> {
    constructor() {
        super("c1.api.requestcatalog.v1.BrowsableAppWithResourceCount", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "binding", kind: "message", T: () => AppEntitlementUserView },
            { no: 3, name: "resource_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<BrowsableAppWithResourceCount>): BrowsableAppWithResourceCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceCount = 0;
        if (value !== undefined)
            reflectionMergePartial<BrowsableAppWithResourceCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BrowsableAppWithResourceCount): BrowsableAppWithResourceCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* c1.api.app.v1.AppEntitlementUserView binding */ 2:
                    message.binding = AppEntitlementUserView.internalBinaryRead(reader, reader.uint32(), options, message.binding);
                    break;
                case /* int32 resource_count */ 3:
                    message.resourceCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BrowsableAppWithResourceCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementUserView binding = 2; */
        if (message.binding)
            AppEntitlementUserView.internalBinaryWrite(message.binding, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 resource_count = 3; */
        if (message.resourceCount !== 0)
            writer.tag(3, WireType.Varint).int32(message.resourceCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BrowsableAppWithResourceCount
 */
export const BrowsableAppWithResourceCount = new BrowsableAppWithResourceCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse$Type extends MessageType<RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithGrantStatus },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse>): RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse): RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.AppWithGrantStatus list */ 1:
                    message.list.push(AppWithGrantStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.AppWithGrantStatus list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppWithGrantStatus.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse
 */
export const RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse = new RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsResponse$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BrowsableAppWithResourceCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppsResponse>): RequestCatalogSearchServiceSearchBrowsableAppsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppsResponse): RequestCatalogSearchServiceSearchBrowsableAppsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.BrowsableAppWithResourceCount list */ 1:
                    message.list.push(BrowsableAppWithResourceCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.BrowsableAppWithResourceCount list = 1; */
        for (let i = 0; i < message.list.length; i++)
            BrowsableAppWithResourceCount.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsResponse
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsResponse = new RequestCatalogSearchServiceSearchBrowsableAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BundleAppsWithCount$Type extends MessageType<BundleAppsWithCount> {
    constructor() {
        super("c1.api.requestcatalog.v1.BundleAppsWithCount", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "app_entitlements_granted", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "app_entitlements_total", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<BundleAppsWithCount>): BundleAppsWithCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appEntitlementsGranted = 0;
        message.appEntitlementsTotal = 0;
        if (value !== undefined)
            reflectionMergePartial<BundleAppsWithCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BundleAppsWithCount): BundleAppsWithCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.App app */ 1:
                    message.app = App.internalBinaryRead(reader, reader.uint32(), options, message.app);
                    break;
                case /* int32 app_entitlements_granted */ 2:
                    message.appEntitlementsGranted = reader.int32();
                    break;
                case /* int32 app_entitlements_total */ 3:
                    message.appEntitlementsTotal = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BundleAppsWithCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.App app = 1; */
        if (message.app)
            App.internalBinaryWrite(message.app, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 app_entitlements_granted = 2; */
        if (message.appEntitlementsGranted !== 0)
            writer.tag(2, WireType.Varint).int32(message.appEntitlementsGranted);
        /* int32 app_entitlements_total = 3; */
        if (message.appEntitlementsTotal !== 0)
            writer.tag(3, WireType.Varint).int32(message.appEntitlementsTotal);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.BundleAppsWithCount
 */
export const BundleAppsWithCount = new BundleAppsWithCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BundleAppsWithCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse>): RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse): RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.BundleAppsWithCount list */ 1:
                    message.list.push(BundleAppsWithCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.BundleAppsWithCount list = 1; */
        for (let i = 0; i < message.list.length; i++)
            BundleAppsWithCount.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse
 */
export const RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse = new RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchTasksForResourcesRequest$Type extends MessageType<RequestCatalogSearchServiceSearchTasksForResourcesRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchTasksForResourcesRequest>): RequestCatalogSearchServiceSearchTasksForResourcesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.resourceIds = [];
        message.excludeResourceTypeIds = [];
        message.appUserIds = [];
        message.catalogIds = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchTasksForResourcesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchTasksForResourcesRequest): RequestCatalogSearchServiceSearchTasksForResourcesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* repeated string resource_ids */ 5:
                    message.resourceIds.push(reader.string());
                    break;
                case /* repeated string exclude_resource_type_ids */ 6:
                    message.excludeResourceTypeIds.push(reader.string());
                    break;
                case /* repeated string app_user_ids */ 7:
                    message.appUserIds.push(reader.string());
                    break;
                case /* repeated string catalog_ids */ 8:
                    message.catalogIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchTasksForResourcesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* repeated string resource_ids = 5; */
        for (let i = 0; i < message.resourceIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.resourceIds[i]);
        /* repeated string exclude_resource_type_ids = 6; */
        for (let i = 0; i < message.excludeResourceTypeIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.excludeResourceTypeIds[i]);
        /* repeated string app_user_ids = 7; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* repeated string catalog_ids = 8; */
        for (let i = 0; i < message.catalogIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.catalogIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesRequest
 */
export const RequestCatalogSearchServiceSearchTasksForResourcesRequest = new RequestCatalogSearchServiceSearchTasksForResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsPerAppRef$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsPerAppRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchEntitlementsPerAppRef>): RequestCatalogSearchServiceSearchEntitlementsPerAppRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.entitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchEntitlementsPerAppRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchEntitlementsPerAppRef): RequestCatalogSearchServiceSearchEntitlementsPerAppRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string entitlement_id */ 2:
                    message.entitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchEntitlementsPerAppRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string entitlement_id = 2; */
        if (message.entitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef
 */
export const RequestCatalogSearchServiceSearchEntitlementsPerAppRef = new RequestCatalogSearchServiceSearchEntitlementsPerAppRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 5, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 6, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogSearchServiceSearchEntitlementsPerAppRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 11, name: "catalog_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchEntitlementsPerAppRequest>): RequestCatalogSearchServiceSearchEntitlementsPerAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.query = "";
        message.resourceTypeIds = [];
        message.pageSize = 0;
        message.pageToken = "";
        message.resourceIds = [];
        message.excludeResourceTypeIds = [];
        message.appUserIds = [];
        message.refs = [];
        message.catalogIds = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchEntitlementsPerAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchEntitlementsPerAppRequest): RequestCatalogSearchServiceSearchEntitlementsPerAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string resource_type_ids */ 4:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* int32 page_size */ 5:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 6:
                    message.pageToken = reader.string();
                    break;
                case /* repeated string resource_ids */ 7:
                    message.resourceIds.push(reader.string());
                    break;
                case /* repeated string exclude_resource_type_ids */ 8:
                    message.excludeResourceTypeIds.push(reader.string());
                    break;
                case /* repeated string app_user_ids */ 9:
                    message.appUserIds.push(reader.string());
                    break;
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef refs */ 10:
                    message.refs.push(RequestCatalogSearchServiceSearchEntitlementsPerAppRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string catalog_ids */ 11:
                    message.catalogIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchEntitlementsPerAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string resource_type_ids = 4; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* int32 page_size = 5; */
        if (message.pageSize !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageSize);
        /* string page_token = 6; */
        if (message.pageToken !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.pageToken);
        /* repeated string resource_ids = 7; */
        for (let i = 0; i < message.resourceIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.resourceIds[i]);
        /* repeated string exclude_resource_type_ids = 8; */
        for (let i = 0; i < message.excludeResourceTypeIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.excludeResourceTypeIds[i]);
        /* repeated string app_user_ids = 9; */
        for (let i = 0; i < message.appUserIds.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.appUserIds[i]);
        /* repeated c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRef refs = 10; */
        for (let i = 0; i < message.refs.length; i++)
            RequestCatalogSearchServiceSearchEntitlementsPerAppRef.internalBinaryWrite(message.refs[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated string catalog_ids = 11; */
        for (let i = 0; i < message.catalogIds.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.catalogIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppRequest
 */
export const RequestCatalogSearchServiceSearchEntitlementsPerAppRequest = new RequestCatalogSearchServiceSearchEntitlementsPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogUserEntitlementPerApp },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchEntitlementsPerAppResponse>): RequestCatalogSearchServiceSearchEntitlementsPerAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchEntitlementsPerAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchEntitlementsPerAppResponse): RequestCatalogSearchServiceSearchEntitlementsPerAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp list */ 1:
                    message.list.push(RequestCatalogUserEntitlementPerApp.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchEntitlementsPerAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalogUserEntitlementPerApp.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsPerAppResponse
 */
export const RequestCatalogSearchServiceSearchEntitlementsPerAppResponse = new RequestCatalogSearchServiceSearchEntitlementsPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest>): RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest): RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest
 */
export const RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest = new RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse>): RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse): RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse
 */
export const RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse = new RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsForUserRequest$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsForUserRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27})?$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 6, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "grant_enrollment_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.GrantEnrollmentStatus", GrantEnrollmentStatus, "GRANT_ENROLLMENT_STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchEntitlementsForUserRequest>): RequestCatalogSearchServiceSearchEntitlementsForUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.grantEnrollmentStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchEntitlementsForUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchEntitlementsForUserRequest): RequestCatalogSearchServiceSearchEntitlementsForUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 5:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 6:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status */ 7:
                    message.grantEnrollmentStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchEntitlementsForUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 5; */
        if (message.pageSize !== 0)
            writer.tag(5, WireType.Varint).int32(message.pageSize);
        /* string page_token = 6; */
        if (message.pageToken !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.requestcatalog.v1.GrantEnrollmentStatus grant_enrollment_status = 7; */
        if (message.grantEnrollmentStatus !== 0)
            writer.tag(7, WireType.Varint).int32(message.grantEnrollmentStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserRequest
 */
export const RequestCatalogSearchServiceSearchEntitlementsForUserRequest = new RequestCatalogSearchServiceSearchEntitlementsForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchEntitlementsForUserResponse$Type extends MessageType<RequestCatalogSearchServiceSearchEntitlementsForUserResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogUserEntitlementPerApp },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchEntitlementsForUserResponse>): RequestCatalogSearchServiceSearchEntitlementsForUserResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchEntitlementsForUserResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchEntitlementsForUserResponse): RequestCatalogSearchServiceSearchEntitlementsForUserResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp list */ 1:
                    message.list.push(RequestCatalogUserEntitlementPerApp.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchEntitlementsForUserResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalogUserEntitlementPerApp.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchEntitlementsForUserResponse
 */
export const RequestCatalogSearchServiceSearchEntitlementsForUserResponse = new RequestCatalogSearchServiceSearchEntitlementsForUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchTasksForResourcesResponse$Type extends MessageType<RequestCatalogSearchServiceSearchTasksForResourcesResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogResourceHasTask },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchTasksForResourcesResponse>): RequestCatalogSearchServiceSearchTasksForResourcesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchTasksForResourcesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchTasksForResourcesResponse): RequestCatalogSearchServiceSearchTasksForResourcesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogResourceHasTask list */ 1:
                    message.list.push(RequestCatalogResourceHasTask.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchTasksForResourcesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalogResourceHasTask list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalogResourceHasTask.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchTasksForResourcesResponse
 */
export const RequestCatalogSearchServiceSearchTasksForResourcesResponse = new RequestCatalogSearchServiceSearchTasksForResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogUserEntitlementPerApp$Type extends MessageType<RequestCatalogUserEntitlementPerApp> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "app_entitlement_user_binding", kind: "message", T: () => AppEntitlementUserView },
            { no: 3, name: "task", kind: "message", T: () => Task }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogUserEntitlementPerApp>): RequestCatalogUserEntitlementPerApp {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogUserEntitlementPerApp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogUserEntitlementPerApp): RequestCatalogUserEntitlementPerApp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView entitlement */ 1:
                    message.entitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding */ 2:
                    message.appEntitlementUserBinding = AppEntitlementUserView.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementUserBinding);
                    break;
                case /* c1.api.task.v1.Task task */ 3:
                    message.task = Task.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogUserEntitlementPerApp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView entitlement = 1; */
        if (message.entitlement)
            AppEntitlementView.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2; */
        if (message.appEntitlementUserBinding)
            AppEntitlementUserView.internalBinaryWrite(message.appEntitlementUserBinding, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.Task task = 3; */
        if (message.task)
            Task.internalBinaryWrite(message.task, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogUserEntitlementPerApp
 */
export const RequestCatalogUserEntitlementPerApp = new RequestCatalogUserEntitlementPerApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogResourceHasTask$Type extends MessageType<RequestCatalogResourceHasTask> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogResourceHasTask", [
            { no: 1, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "has_task", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogResourceHasTask>): RequestCatalogResourceHasTask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceId = "";
        message.hasTask = false;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogResourceHasTask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogResourceHasTask): RequestCatalogResourceHasTask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string resource_id */ 1:
                    message.resourceId = reader.string();
                    break;
                case /* bool has_task */ 2:
                    message.hasTask = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogResourceHasTask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string resource_id = 1; */
        if (message.resourceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.resourceId);
        /* bool has_task = 2; */
        if (message.hasTask !== false)
            writer.tag(2, WireType.Varint).bool(message.hasTask);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogResourceHasTask
 */
export const RequestCatalogResourceHasTask = new RequestCatalogResourceHasTask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest>): RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest): RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 3:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).int32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest
 */
export const RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest = new RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogUserAccessEntitlementPerApp },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse>): RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse): RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp list */ 1:
                    message.list.push(RequestCatalogUserAccessEntitlementPerApp.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalogUserAccessEntitlementPerApp.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse
 */
export const RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse = new RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogUserAccessEntitlementPerApp$Type extends MessageType<RequestCatalogUserAccessEntitlementPerApp> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "app_entitlement_user_binding", kind: "message", T: () => AppEntitlementUserView },
            { no: 3, name: "task", kind: "message", T: () => Task },
            { no: 4, name: "isRequestable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogUserAccessEntitlementPerApp>): RequestCatalogUserAccessEntitlementPerApp {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isRequestable = false;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogUserAccessEntitlementPerApp>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogUserAccessEntitlementPerApp): RequestCatalogUserAccessEntitlementPerApp {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementView entitlement */ 1:
                    message.entitlement = AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding */ 2:
                    message.appEntitlementUserBinding = AppEntitlementUserView.internalBinaryRead(reader, reader.uint32(), options, message.appEntitlementUserBinding);
                    break;
                case /* c1.api.task.v1.Task task */ 3:
                    message.task = Task.internalBinaryRead(reader, reader.uint32(), options, message.task);
                    break;
                case /* bool isRequestable */ 4:
                    message.isRequestable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogUserAccessEntitlementPerApp, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementView entitlement = 1; */
        if (message.entitlement)
            AppEntitlementView.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2; */
        if (message.appEntitlementUserBinding)
            AppEntitlementUserView.internalBinaryWrite(message.appEntitlementUserBinding, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.task.v1.Task task = 3; */
        if (message.task)
            Task.internalBinaryWrite(message.task, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* bool isRequestable = 4; */
        if (message.isRequestable !== false)
            writer.tag(4, WireType.Varint).bool(message.isRequestable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogUserAccessEntitlementPerApp
 */
export const RequestCatalogUserAccessEntitlementPerApp = new RequestCatalogUserAccessEntitlementPerApp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalog$Type extends MessageType<RequestCatalog> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "created_by_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "access_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlement },
            { no: 9, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "published", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 12, name: "request_bundle", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "enrollment_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior", RequestCatalogEnrollmentBehavior, "REQUEST_CATALOG_ENROLLMENT_BEHAVIOR_"] },
            { no: 14, name: "unenrollment_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior", RequestCatalogUnenrollmentBehavior, "REQUEST_CATALOG_UNENROLLMENT_BEHAVIOR_"] },
            { no: 15, name: "unenrollment_entitlement_behavior", kind: "enum", T: () => ["c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior", RequestCatalogUnenrollmentEntitlementBehavior, "REQUEST_CATALOG_UNENROLLMENT_ENTITLEMENT_BEHAVIOR_"] }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Access_Profile" } }] } });
    }
    create(value?: PartialMessage<RequestCatalog>): RequestCatalog {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.createdByUserId = "";
        message.accessEntitlements = [];
        message.visibleToEveryone = false;
        message.published = false;
        message.requestBundle = false;
        message.enrollmentBehavior = 0;
        message.unenrollmentBehavior = 0;
        message.unenrollmentEntitlementBehavior = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalog): RequestCatalog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 11:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string created_by_user_id */ 6:
                    message.createdByUserId = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlement access_entitlements */ 8:
                    message.accessEntitlements.push(AppEntitlement.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool visible_to_everyone */ 9:
                    message.visibleToEveryone = reader.bool();
                    break;
                case /* bool published */ 10:
                    message.published = reader.bool();
                    break;
                case /* bool request_bundle */ 12:
                    message.requestBundle = reader.bool();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior enrollment_behavior */ 13:
                    message.enrollmentBehavior = reader.int32();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior unenrollment_behavior */ 14:
                    message.unenrollmentBehavior = reader.int32();
                    break;
                case /* c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior unenrollment_entitlement_behavior */ 15:
                    message.unenrollmentEntitlementBehavior = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string created_by_user_id = 6; */
        if (message.createdByUserId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.createdByUserId);
        /* repeated c1.api.app.v1.AppEntitlement access_entitlements = 8; */
        for (let i = 0; i < message.accessEntitlements.length; i++)
            AppEntitlement.internalBinaryWrite(message.accessEntitlements[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool visible_to_everyone = 9; */
        if (message.visibleToEveryone !== false)
            writer.tag(9, WireType.Varint).bool(message.visibleToEveryone);
        /* bool published = 10; */
        if (message.published !== false)
            writer.tag(10, WireType.Varint).bool(message.published);
        /* google.protobuf.Timestamp deleted_at = 11; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* bool request_bundle = 12; */
        if (message.requestBundle !== false)
            writer.tag(12, WireType.Varint).bool(message.requestBundle);
        /* c1.api.requestcatalog.v1.RequestCatalogEnrollmentBehavior enrollment_behavior = 13; */
        if (message.enrollmentBehavior !== 0)
            writer.tag(13, WireType.Varint).int32(message.enrollmentBehavior);
        /* c1.api.requestcatalog.v1.RequestCatalogUnenrollmentBehavior unenrollment_behavior = 14; */
        if (message.unenrollmentBehavior !== 0)
            writer.tag(14, WireType.Varint).int32(message.unenrollmentBehavior);
        /* c1.api.requestcatalog.v1.RequestCatalogUnenrollmentEntitlementBehavior unenrollment_entitlement_behavior = 15; */
        if (message.unenrollmentEntitlementBehavior !== 0)
            writer.tag(15, WireType.Varint).int32(message.unenrollmentEntitlementBehavior);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalog
 */
export const RequestCatalog = new RequestCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogView$Type extends MessageType<RequestCatalogView> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogView", [
            { no: 1, name: "request_catalog", kind: "message", T: () => RequestCatalog },
            { no: 2, name: "created_by_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "access_entitlements_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "member_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogView>): RequestCatalogView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.createdByUserPath = "";
        message.accessEntitlementsPath = "";
        message.memberCount = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogView): RequestCatalogView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.RequestCatalog request_catalog */ 1:
                    message.requestCatalog = RequestCatalog.internalBinaryRead(reader, reader.uint32(), options, message.requestCatalog);
                    break;
                case /* string created_by_user_path */ 2:
                    message.createdByUserPath = reader.string();
                    break;
                case /* string access_entitlements_path */ 4:
                    message.accessEntitlementsPath = reader.string();
                    break;
                case /* int64 member_count */ 5:
                    message.memberCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.RequestCatalog request_catalog = 1; */
        if (message.requestCatalog)
            RequestCatalog.internalBinaryWrite(message.requestCatalog, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string created_by_user_path = 2; */
        if (message.createdByUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.createdByUserPath);
        /* string access_entitlements_path = 4; */
        if (message.accessEntitlementsPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.accessEntitlementsPath);
        /* int64 member_count = 5; */
        if (message.memberCount !== 0)
            writer.tag(5, WireType.Varint).int64(message.memberCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogView
 */
export const RequestCatalogView = new RequestCatalogView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogExpandMask$Type extends MessageType<RequestCatalogExpandMask> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "created_by_user_id", "app_ids", "access_entitlements"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogExpandMask>): RequestCatalogExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogExpandMask): RequestCatalogExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogExpandMask
 */
export const RequestCatalogExpandMask = new RequestCatalogExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchResourceTypesPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchResourceTypesPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchResourceTypesPerAppRequest>): RequestCatalogSearchServiceSearchResourceTypesPerAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.resourceTypeIds = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchResourceTypesPerAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchResourceTypesPerAppRequest): RequestCatalogSearchServiceSearchResourceTypesPerAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                case /* repeated string resource_type_ids */ 6:
                    message.resourceTypeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchResourceTypesPerAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        /* repeated string resource_type_ids = 6; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppRequest
 */
export const RequestCatalogSearchServiceSearchResourceTypesPerAppRequest = new RequestCatalogSearchServiceSearchResourceTypesPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypeWithEntitlementCount$Type extends MessageType<ResourceTypeWithEntitlementCount> {
    constructor() {
        super("c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount", [
            { no: 1, name: "resource", kind: "message", T: () => AppResourceType },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<ResourceTypeWithEntitlementCount>): ResourceTypeWithEntitlementCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<ResourceTypeWithEntitlementCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceTypeWithEntitlementCount): ResourceTypeWithEntitlementCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppResourceType resource */ 1:
                    message.resource = AppResourceType.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                case /* int64 count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceTypeWithEntitlementCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppResourceType resource = 1; */
        if (message.resource)
            AppResourceType.internalBinaryWrite(message.resource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount
 */
export const ResourceTypeWithEntitlementCount = new ResourceTypeWithEntitlementCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchResourceTypesPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchResourceTypesPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceTypeWithEntitlementCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchResourceTypesPerAppResponse>): RequestCatalogSearchServiceSearchResourceTypesPerAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchResourceTypesPerAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchResourceTypesPerAppResponse): RequestCatalogSearchServiceSearchResourceTypesPerAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount list */ 1:
                    message.list.push(ResourceTypeWithEntitlementCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchResourceTypesPerAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.ResourceTypeWithEntitlementCount list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ResourceTypeWithEntitlementCount.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourceTypesPerAppResponse
 */
export const RequestCatalogSearchServiceSearchResourceTypesPerAppResponse = new RequestCatalogSearchServiceSearchResourceTypesPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CatalogRef$Type extends MessageType<CatalogRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.CatalogRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<CatalogRef>): CatalogRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<CatalogRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CatalogRef): CatalogRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CatalogRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CatalogRef
 */
export const CatalogRef = new CatalogRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogsRequest$Type extends MessageType<SearchRequestCatalogsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CatalogRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "include_app_catalogs", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SearchRequestCatalogsRequest>): SearchRequestCatalogsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appEntitlements = [];
        message.refs = [];
        message.includeAppCatalogs = false;
        if (value !== undefined)
            reflectionMergePartial<SearchRequestCatalogsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequestCatalogsRequest): SearchRequestCatalogsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements */ 4:
                    message.appEntitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.requestcatalog.v1.CatalogRef refs */ 5:
                    message.refs.push(CatalogRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool include_app_catalogs */ 6:
                    message.includeAppCatalogs = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequestCatalogsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 4; */
        for (let i = 0; i < message.appEntitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlements[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.requestcatalog.v1.CatalogRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            CatalogRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* bool include_app_catalogs = 6; */
        if (message.includeAppCatalogs !== false)
            writer.tag(6, WireType.Varint).bool(message.includeAppCatalogs);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsRequest
 */
export const SearchRequestCatalogsRequest = new SearchRequestCatalogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogsResponse$Type extends MessageType<SearchRequestCatalogsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchRequestCatalogsResponse>): SearchRequestCatalogsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchRequestCatalogsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequestCatalogsResponse): SearchRequestCatalogsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalog list */ 1:
                    message.list.push(RequestCatalog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequestCatalogsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalog list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalog.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsResponse
 */
export const SearchRequestCatalogsResponse = new SearchRequestCatalogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogsWithEnrollmentCountsRequest$Type extends MessageType<SearchRequestCatalogsWithEnrollmentCountsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CatalogRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchRequestCatalogsWithEnrollmentCountsRequest>): SearchRequestCatalogsWithEnrollmentCountsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appEntitlements = [];
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchRequestCatalogsWithEnrollmentCountsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequestCatalogsWithEnrollmentCountsRequest): SearchRequestCatalogsWithEnrollmentCountsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements */ 4:
                    message.appEntitlements.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.requestcatalog.v1.CatalogRef refs */ 5:
                    message.refs.push(CatalogRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequestCatalogsWithEnrollmentCountsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlements = 4; */
        for (let i = 0; i < message.appEntitlements.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlements[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.requestcatalog.v1.CatalogRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            CatalogRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsRequest
 */
export const SearchRequestCatalogsWithEnrollmentCountsRequest = new SearchRequestCatalogsWithEnrollmentCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogsWithEnrollmentCountsResponse$Type extends MessageType<SearchRequestCatalogsWithEnrollmentCountsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogWithEnrollmentCountView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchRequestCatalogsWithEnrollmentCountsResponse>): SearchRequestCatalogsWithEnrollmentCountsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchRequestCatalogsWithEnrollmentCountsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequestCatalogsWithEnrollmentCountsResponse): SearchRequestCatalogsWithEnrollmentCountsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView list */ 1:
                    message.list.push(RequestCatalogWithEnrollmentCountView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequestCatalogsWithEnrollmentCountsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalogWithEnrollmentCountView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogsWithEnrollmentCountsResponse
 */
export const SearchRequestCatalogsWithEnrollmentCountsResponse = new SearchRequestCatalogsWithEnrollmentCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogWithEnrollmentCountView$Type extends MessageType<RequestCatalogWithEnrollmentCountView> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView", [
            { no: 1, name: "request_catalog", kind: "message", T: () => RequestCatalog },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogWithEnrollmentCountView>): RequestCatalogWithEnrollmentCountView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogWithEnrollmentCountView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogWithEnrollmentCountView): RequestCatalogWithEnrollmentCountView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.RequestCatalog request_catalog */ 1:
                    message.requestCatalog = RequestCatalog.internalBinaryRead(reader, reader.uint32(), options, message.requestCatalog);
                    break;
                case /* int64 count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogWithEnrollmentCountView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.RequestCatalog request_catalog = 1; */
        if (message.requestCatalog)
            RequestCatalog.internalBinaryWrite(message.requestCatalog, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int64 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogWithEnrollmentCountView
 */
export const RequestCatalogWithEnrollmentCountView = new RequestCatalogWithEnrollmentCountView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithRequestCatalogsRef$Type extends MessageType<AppEntitlementWithRequestCatalogsRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogsRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementWithRequestCatalogsRef>): AppEntitlementWithRequestCatalogsRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementWithRequestCatalogsRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementWithRequestCatalogsRef): AppEntitlementWithRequestCatalogsRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementWithRequestCatalogsRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogsRef
 */
export const AppEntitlementWithRequestCatalogsRef = new AppEntitlementWithRequestCatalogsRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithRequestCatalogs$Type extends MessageType<AppEntitlementWithRequestCatalogs> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_resource", kind: "message", T: () => AppResource },
            { no: 3, name: "app_resource_type", kind: "message", T: () => AppResourceType },
            { no: 4, name: "catalogs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalog }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementWithRequestCatalogs>): AppEntitlementWithRequestCatalogs {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogs = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementWithRequestCatalogs>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementWithRequestCatalogs): AppEntitlementWithRequestCatalogs {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlement entitlement */ 1:
                    message.entitlement = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                case /* c1.api.app.v1.AppResource app_resource */ 2:
                    message.appResource = AppResource.internalBinaryRead(reader, reader.uint32(), options, message.appResource);
                    break;
                case /* c1.api.app.v1.AppResourceType app_resource_type */ 3:
                    message.appResourceType = AppResourceType.internalBinaryRead(reader, reader.uint32(), options, message.appResourceType);
                    break;
                case /* repeated c1.api.requestcatalog.v1.RequestCatalog catalogs */ 4:
                    message.catalogs.push(RequestCatalog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementWithRequestCatalogs, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlement entitlement = 1; */
        if (message.entitlement)
            AppEntitlement.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppResource app_resource = 2; */
        if (message.appResource)
            AppResource.internalBinaryWrite(message.appResource, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppResourceType app_resource_type = 3; */
        if (message.appResourceType)
            AppResourceType.internalBinaryWrite(message.appResourceType, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.requestcatalog.v1.RequestCatalog catalogs = 4; */
        for (let i = 0; i < message.catalogs.length; i++)
            RequestCatalog.internalBinaryWrite(message.catalogs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs
 */
export const AppEntitlementWithRequestCatalogs = new AppEntitlementWithRequestCatalogs$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithRequestCatalogsRequest$Type extends MessageType<SearchAppEntitlementsWithRequestCatalogsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 6, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "alias", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z0-9][-a-z0-9_.]{0,61}[a-z0-9]$", ignoreEmpty: true } } } },
            { no: 8, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithRequestCatalogsRequest>): SearchAppEntitlementsWithRequestCatalogsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.query = "";
        message.resourceTypeIds = [];
        message.excludeResourceTypeIds = [];
        message.alias = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithRequestCatalogsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithRequestCatalogsRequest): SearchAppEntitlementsWithRequestCatalogsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string resource_type_ids */ 5:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* repeated string exclude_resource_type_ids */ 6:
                    message.excludeResourceTypeIds.push(reader.string());
                    break;
                case /* string alias */ 7:
                    message.alias = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef refs */ 8:
                    message.refs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithRequestCatalogsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string resource_type_ids = 5; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* repeated string exclude_resource_type_ids = 6; */
        for (let i = 0; i < message.excludeResourceTypeIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.excludeResourceTypeIds[i]);
        /* string alias = 7; */
        if (message.alias !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.alias);
        /* repeated c1.api.app.v1.AppEntitlementRef refs = 8; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.refs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsRequest
 */
export const SearchAppEntitlementsWithRequestCatalogsRequest = new SearchAppEntitlementsWithRequestCatalogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithRequestCatalogsResponse$Type extends MessageType<SearchAppEntitlementsWithRequestCatalogsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithRequestCatalogs },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsWithRequestCatalogsResponse>): SearchAppEntitlementsWithRequestCatalogsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsWithRequestCatalogsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsWithRequestCatalogsResponse): SearchAppEntitlementsWithRequestCatalogsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs list */ 1:
                    message.list.push(AppEntitlementWithRequestCatalogs.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsWithRequestCatalogsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementWithRequestCatalogs.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsWithRequestCatalogsResponse
 */
export const SearchAppEntitlementsWithRequestCatalogsResponse = new SearchAppEntitlementsWithRequestCatalogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementWithRequestCatalogsRequest$Type extends MessageType<GetAppEntitlementWithRequestCatalogsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementWithRequestCatalogsRequest>): GetAppEntitlementWithRequestCatalogsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementWithRequestCatalogsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementWithRequestCatalogsRequest): GetAppEntitlementWithRequestCatalogsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string id */ 2:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementWithRequestCatalogsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string id = 2; */
        if (message.id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsRequest
 */
export const GetAppEntitlementWithRequestCatalogsRequest = new GetAppEntitlementWithRequestCatalogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementWithRequestCatalogsResponse$Type extends MessageType<GetAppEntitlementWithRequestCatalogsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsResponse", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementWithRequestCatalogs }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementWithRequestCatalogsResponse>): GetAppEntitlementWithRequestCatalogsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementWithRequestCatalogsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementWithRequestCatalogsResponse): GetAppEntitlementWithRequestCatalogsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs entitlement */ 1:
                    message.entitlement = AppEntitlementWithRequestCatalogs.internalBinaryRead(reader, reader.uint32(), options, message.entitlement);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementWithRequestCatalogsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.AppEntitlementWithRequestCatalogs entitlement = 1; */
        if (message.entitlement)
            AppEntitlementWithRequestCatalogs.internalBinaryWrite(message.entitlement, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.GetAppEntitlementWithRequestCatalogsResponse
 */
export const GetAppEntitlementWithRequestCatalogsResponse = new GetAppEntitlementWithRequestCatalogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchResourcesPerAppRequest$Type extends MessageType<RequestCatalogSearchServiceSearchResourcesPerAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchResourcesPerAppRequest>): RequestCatalogSearchServiceSearchResourcesPerAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.appId = "";
        message.query = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.resourceIds = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchResourcesPerAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchResourcesPerAppRequest): RequestCatalogSearchServiceSearchResourcesPerAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* int32 page_size */ 4:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 5:
                    message.pageToken = reader.string();
                    break;
                case /* repeated string resource_ids */ 6:
                    message.resourceIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchResourcesPerAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* int32 page_size = 4; */
        if (message.pageSize !== 0)
            writer.tag(4, WireType.Varint).int32(message.pageSize);
        /* string page_token = 5; */
        if (message.pageToken !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.pageToken);
        /* repeated string resource_ids = 6; */
        for (let i = 0; i < message.resourceIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.resourceIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppRequest
 */
export const RequestCatalogSearchServiceSearchResourcesPerAppRequest = new RequestCatalogSearchServiceSearchResourcesPerAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceWithEntitlementCount$Type extends MessageType<ResourceWithEntitlementCount> {
    constructor() {
        super("c1.api.requestcatalog.v1.ResourceWithEntitlementCount", [
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "item", kind: "message", T: () => AppResourceView },
            { no: 4, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ResourceWithEntitlementCount>): ResourceWithEntitlementCount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ResourceWithEntitlementCount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceWithEntitlementCount): ResourceWithEntitlementCount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 2:
                    message.count = reader.int64().toNumber();
                    break;
                case /* c1.api.app.v1.AppResourceView item */ 3:
                    message.item = AppResourceView.internalBinaryRead(reader, reader.uint32(), options, message.item);
                    break;
                case /* repeated google.protobuf.Any expanded */ 4:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceWithEntitlementCount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int64(message.count);
        /* c1.api.app.v1.AppResourceView item = 3; */
        if (message.item)
            AppResourceView.internalBinaryWrite(message.item, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 4; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.ResourceWithEntitlementCount
 */
export const ResourceWithEntitlementCount = new ResourceWithEntitlementCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchResourcesPerAppResponse$Type extends MessageType<RequestCatalogSearchServiceSearchResourcesPerAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceWithEntitlementCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchResourcesPerAppResponse>): RequestCatalogSearchServiceSearchResourcesPerAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchResourcesPerAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchResourcesPerAppResponse): RequestCatalogSearchServiceSearchResourcesPerAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.ResourceWithEntitlementCount list */ 1:
                    message.list.push(ResourceWithEntitlementCount.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchResourcesPerAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.ResourceWithEntitlementCount list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ResourceWithEntitlementCount.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchResourcesPerAppResponse
 */
export const RequestCatalogSearchServiceSearchResourcesPerAppResponse = new RequestCatalogSearchServiceSearchResourcesPerAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementsInCatalogTermsResponse$Type extends MessageType<AppEntitlementsInCatalogTermsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementsInCatalogTermsResponse>): AppEntitlementsInCatalogTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementsInCatalogTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementsInCatalogTermsResponse): AppEntitlementsInCatalogTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementsInCatalogTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsResponse
 */
export const AppEntitlementsInCatalogTermsResponse = new AppEntitlementsInCatalogTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementsInCatalogTermsRequest$Type extends MessageType<AppEntitlementsInCatalogTermsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => SearchAppEntitlementsInCatalogRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest.TermType", AppEntitlementsInCatalogTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementsInCatalogTermsRequest>): AppEntitlementsInCatalogTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementsInCatalogTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementsInCatalogTermsRequest): AppEntitlementsInCatalogTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest search */ 1:
                    message.search = SearchAppEntitlementsInCatalogRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest.TermType term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementsInCatalogTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest search = 1; */
        if (message.search)
            SearchAppEntitlementsInCatalogRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest.TermType term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppEntitlementsInCatalogTermsRequest
 */
export const AppEntitlementsInCatalogTermsRequest = new AppEntitlementsInCatalogTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRemovedUsersRequest$Type extends MessageType<SearchRemovedUsersRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRemovedUsersRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchRemovedUsersRequest>): SearchRemovedUsersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchRemovedUsersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRemovedUsersRequest): SearchRemovedUsersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRemovedUsersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRemovedUsersRequest
 */
export const SearchRemovedUsersRequest = new SearchRemovedUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourcesInCatalogRequest$Type extends MessageType<SearchAppResourcesInCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppResourcesInCatalogRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppResourceExpandMask },
            { no: 7, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppResourcesInCatalogRequest>): SearchAppResourcesInCatalogRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppResourcesInCatalogRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppResourcesInCatalogRequest): SearchAppResourcesInCatalogRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppResourceRef refs */ 5:
                    message.refs.push(AppResourceRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.app.v1.AppResourceExpandMask expand_mask */ 6:
                    message.expandMask = AppResourceExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated string app_ids */ 7:
                    message.appIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppResourcesInCatalogRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.app.v1.AppResourceRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            AppResourceRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppResourceExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppResourceExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string app_ids = 7; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.appIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppResourcesInCatalogRequest
 */
export const SearchAppResourcesInCatalogRequest = new SearchAppResourcesInCatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountUsersLosingMembershipRequest$Type extends MessageType<CountUsersLosingMembershipRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.CountUsersLosingMembershipRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<CountUsersLosingMembershipRequest>): CountUsersLosingMembershipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        if (value !== undefined)
            reflectionMergePartial<CountUsersLosingMembershipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountUsersLosingMembershipRequest): CountUsersLosingMembershipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountUsersLosingMembershipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CountUsersLosingMembershipRequest
 */
export const CountUsersLosingMembershipRequest = new CountUsersLosingMembershipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountUsersLosingMembershipResponse$Type extends MessageType<CountUsersLosingMembershipResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.CountUsersLosingMembershipResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<CountUsersLosingMembershipResponse>): CountUsersLosingMembershipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<CountUsersLosingMembershipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CountUsersLosingMembershipResponse): CountUsersLosingMembershipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CountUsersLosingMembershipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.CountUsersLosingMembershipResponse
 */
export const CountUsersLosingMembershipResponse = new CountUsersLosingMembershipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsInCatalogRequest$Type extends MessageType<SearchAppEntitlementsInCatalogRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 7, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalogAppEntitlementBindingRef },
            { no: 8, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsInCatalogRequest>): SearchAppEntitlementsInCatalogRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.appIds = [];
        message.refs = [];
        message.resourceTypeIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsInCatalogRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsInCatalogRequest): SearchAppEntitlementsInCatalogRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* repeated string app_ids */ 5:
                    message.appIds.push(reader.string());
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 6:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef refs */ 7:
                    message.refs.push(RequestCatalogAppEntitlementBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string resource_type_ids */ 8:
                    message.resourceTypeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsInCatalogRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* repeated string app_ids = 5; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.appIds[i]);
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef refs = 7; */
        for (let i = 0; i < message.refs.length; i++)
            RequestCatalogAppEntitlementBindingRef.internalBinaryWrite(message.refs[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated string resource_type_ids = 8; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(8, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogRequest
 */
export const SearchAppEntitlementsInCatalogRequest = new SearchAppEntitlementsInCatalogRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsInCatalogResponse$Type extends MessageType<SearchAppEntitlementsInCatalogResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogResponse", [
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CatalogEntry }
        ]);
    }
    create(value?: PartialMessage<SearchAppEntitlementsInCatalogResponse>): SearchAppEntitlementsInCatalogResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        message.nextPageToken = "";
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppEntitlementsInCatalogResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppEntitlementsInCatalogResponse): SearchAppEntitlementsInCatalogResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated c1.api.app.v1.CatalogEntry list */ 4:
                    message.list.push(CatalogEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppEntitlementsInCatalogResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated c1.api.app.v1.CatalogEntry list = 4; */
        for (let i = 0; i < message.list.length; i++)
            CatalogEntry.internalBinaryWrite(message.list[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppEntitlementsInCatalogResponse
 */
export const SearchAppEntitlementsInCatalogResponse = new SearchAppEntitlementsInCatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRemovedUsersResponse$Type extends MessageType<SearchRemovedUsersResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRemovedUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchRemovedUsersResponse>): SearchRemovedUsersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchRemovedUsersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRemovedUsersResponse): SearchRemovedUsersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRemovedUsersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRemovedUsersResponse
 */
export const SearchRemovedUsersResponse = new SearchRemovedUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourcesInCatalogResponse$Type extends MessageType<SearchAppResourcesInCatalogResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchAppResourcesInCatalogResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppResourcesInCatalogResponse>): SearchAppResourcesInCatalogResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppResourcesInCatalogResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppResourcesInCatalogResponse): SearchAppResourcesInCatalogResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppResourceView list */ 1:
                    message.list.push(AppResourceView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppResourcesInCatalogResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppResourceView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppResourceView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchAppResourcesInCatalogResponse
 */
export const SearchAppResourcesInCatalogResponse = new SearchAppResourcesInCatalogResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogBundlesRequest$Type extends MessageType<SearchRequestCatalogBundlesRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogBundlesRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "include_enrollment_disabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "enrollment_status", kind: "enum", T: () => ["c1.api.requestcatalog.v1.GrantEnrollmentStatus", GrantEnrollmentStatus, "GRANT_ENROLLMENT_STATUS_"] }
        ]);
    }
    create(value?: PartialMessage<SearchRequestCatalogBundlesRequest>): SearchRequestCatalogBundlesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.includeEnrollmentDisabled = false;
        message.enrollmentStatus = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchRequestCatalogBundlesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequestCatalogBundlesRequest): SearchRequestCatalogBundlesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 4:
                    message.query = reader.string();
                    break;
                case /* bool include_enrollment_disabled */ 5:
                    message.includeEnrollmentDisabled = reader.bool();
                    break;
                case /* c1.api.requestcatalog.v1.GrantEnrollmentStatus enrollment_status */ 6:
                    message.enrollmentStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequestCatalogBundlesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 4; */
        if (message.query !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.query);
        /* bool include_enrollment_disabled = 5; */
        if (message.includeEnrollmentDisabled !== false)
            writer.tag(5, WireType.Varint).bool(message.includeEnrollmentDisabled);
        /* c1.api.requestcatalog.v1.GrantEnrollmentStatus enrollment_status = 6; */
        if (message.enrollmentStatus !== 0)
            writer.tag(6, WireType.Varint).int32(message.enrollmentStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogBundlesRequest
 */
export const SearchRequestCatalogBundlesRequest = new SearchRequestCatalogBundlesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestCatalogBundlesResponse$Type extends MessageType<SearchRequestCatalogBundlesResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.SearchRequestCatalogBundlesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RequestCatalog },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchRequestCatalogBundlesResponse>): SearchRequestCatalogBundlesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchRequestCatalogBundlesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchRequestCatalogBundlesResponse): SearchRequestCatalogBundlesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.RequestCatalog list */ 1:
                    message.list.push(RequestCatalog.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchRequestCatalogBundlesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.RequestCatalog list = 1; */
        for (let i = 0; i < message.list.length; i++)
            RequestCatalog.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.SearchRequestCatalogBundlesResponse
 */
export const SearchRequestCatalogBundlesResponse = new SearchRequestCatalogBundlesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogAppEntitlementBindingRef$Type extends MessageType<RequestCatalogAppEntitlementBindingRef> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef", [
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogAppEntitlementBindingRef>): RequestCatalogAppEntitlementBindingRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogAppEntitlementBindingRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogAppEntitlementBindingRef): RequestCatalogAppEntitlementBindingRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string id */ 3:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogAppEntitlementBindingRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string id = 3; */
        if (message.id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogAppEntitlementBindingRef
 */
export const RequestCatalogAppEntitlementBindingRef = new RequestCatalogAppEntitlementBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessProfileMembershipRequest$Type extends MessageType<AccessProfileMembershipRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessProfileMembershipRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "access_profile_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AccessProfileMembershipRequest>): AccessProfileMembershipRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.accessProfileId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AccessProfileMembershipRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessProfileMembershipRequest): AccessProfileMembershipRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string access_profile_id */ 3:
                    message.accessProfileId = reader.string();
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessProfileMembershipRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string access_profile_id = 3; */
        if (message.accessProfileId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accessProfileId);
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessProfileMembershipRequest
 */
export const AccessProfileMembershipRequest = new AccessProfileMembershipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessProfileMembershipResponse$Type extends MessageType<AccessProfileMembershipResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessProfileMembershipResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessProfileMembership },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AccessProfileMembershipResponse>): AccessProfileMembershipResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AccessProfileMembershipResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessProfileMembershipResponse): AccessProfileMembershipResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.AccessProfileMembership list */ 1:
                    message.list.push(AccessProfileMembership.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessProfileMembershipResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.AccessProfileMembership list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AccessProfileMembership.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessProfileMembershipResponse
 */
export const AccessProfileMembershipResponse = new AccessProfileMembershipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessProfileMembership$Type extends MessageType<AccessProfileMembership> {
    constructor() {
        super("c1.api.requestcatalog.v1.AccessProfileMembership", [
            { no: 1, name: "access_profile", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "user", kind: "message", T: () => User },
            { no: 3, name: "added_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "added_via", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantReason }
        ]);
    }
    create(value?: PartialMessage<AccessProfileMembership>): AccessProfileMembership {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.addedVia = [];
        if (value !== undefined)
            reflectionMergePartial<AccessProfileMembership>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccessProfileMembership): AccessProfileMembership {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlement access_profile */ 1:
                    message.accessProfile = AppEntitlement.internalBinaryRead(reader, reader.uint32(), options, message.accessProfile);
                    break;
                case /* c1.api.user.v1.User user */ 2:
                    message.user = User.internalBinaryRead(reader, reader.uint32(), options, message.user);
                    break;
                case /* google.protobuf.Timestamp added_at */ 3:
                    message.addedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.addedAt);
                    break;
                case /* repeated c1.api.app.v1.GrantReason added_via */ 4:
                    message.addedVia.push(GrantReason.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccessProfileMembership, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlement access_profile = 1; */
        if (message.accessProfile)
            AppEntitlement.internalBinaryWrite(message.accessProfile, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.user.v1.User user = 2; */
        if (message.user)
            User.internalBinaryWrite(message.user, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp added_at = 3; */
        if (message.addedAt)
            Timestamp.internalBinaryWrite(message.addedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.GrantReason added_via = 4; */
        for (let i = 0; i < message.addedVia.length; i++)
            GrantReason.internalBinaryWrite(message.addedVia[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AccessProfileMembership
 */
export const AccessProfileMembership = new AccessProfileMembership$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest>): RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.targetUserId = "";
        message.query = "";
        message.resourceTypeIds = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest): RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string target_user_id */ 2:
                    message.targetUserId = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated string resource_type_ids */ 4:
                    message.resourceTypeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string target_user_id = 2; */
        if (message.targetUserId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.targetUserId);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated string resource_type_ids = 4; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest
 */
export const RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest = new RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceWithEntitlementCountType$Type extends MessageType<AppResourceWithEntitlementCountType> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType", [
            { no: 1, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlement_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppResourceWithEntitlementCountType>): AppResourceWithEntitlementCountType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appResourceTypeId = "";
        message.appEntitlementCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppResourceWithEntitlementCountType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppResourceWithEntitlementCountType): AppResourceWithEntitlementCountType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_resource_type_id */ 1:
                    message.appResourceTypeId = reader.string();
                    break;
                case /* int64 app_entitlement_count */ 2:
                    message.appEntitlementCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppResourceWithEntitlementCountType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_resource_type_id = 1; */
        if (message.appResourceTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appResourceTypeId);
        /* int64 app_entitlement_count = 2; */
        if (message.appEntitlementCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.appEntitlementCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType
 */
export const AppResourceWithEntitlementCountType = new AppResourceWithEntitlementCountType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse$Type extends MessageType<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceWithEntitlementCountType }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse>): RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse): RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType list */ 1:
                    message.list.push(AppResourceWithEntitlementCountType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.AppResourceWithEntitlementCountType list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppResourceWithEntitlementCountType.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse
 */
export const RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse = new RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceEntitlementCountByAppRequest$Type extends MessageType<RequestCatalogSearchServiceEntitlementCountByAppRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceEntitlementCountByAppRequest>): RequestCatalogSearchServiceEntitlementCountByAppRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.query = "";
        message.resourceTypeIds = [];
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceEntitlementCountByAppRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceEntitlementCountByAppRequest): RequestCatalogSearchServiceEntitlementCountByAppRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* string query */ 2:
                    message.query = reader.string();
                    break;
                case /* repeated string resource_type_ids */ 3:
                    message.resourceTypeIds.push(reader.string());
                    break;
                case /* repeated string app_ids */ 4:
                    message.appIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceEntitlementCountByAppRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* string query = 2; */
        if (message.query !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.query);
        /* repeated string resource_type_ids = 3; */
        for (let i = 0; i < message.resourceTypeIds.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.resourceTypeIds[i]);
        /* repeated string app_ids = 4; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.appIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppRequest
 */
export const RequestCatalogSearchServiceEntitlementCountByAppRequest = new RequestCatalogSearchServiceEntitlementCountByAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest>): RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.catalogId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest): RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string catalog_id */ 1:
                    message.catalogId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef refs */ 4:
                    message.refs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.api.app.v1.AppEntitlementExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string catalog_id = 1; */
        if (message.catalogId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.catalogId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.app.v1.AppEntitlementRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest
 */
export const RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest = new RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse$Type extends MessageType<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse>): RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse): RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementView list */ 1:
                    message.list.push(AppEntitlementView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse
 */
export const RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse = new RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithEntitlementCountType$Type extends MessageType<AppWithEntitlementCountType> {
    constructor() {
        super("c1.api.requestcatalog.v1.AppWithEntitlementCountType", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<AppWithEntitlementCountType>): AppWithEntitlementCountType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.entitlementCount = 0;
        if (value !== undefined)
            reflectionMergePartial<AppWithEntitlementCountType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppWithEntitlementCountType): AppWithEntitlementCountType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int64 entitlement_count */ 2:
                    message.entitlementCount = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppWithEntitlementCountType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int64 entitlement_count = 2; */
        if (message.entitlementCount !== 0)
            writer.tag(2, WireType.Varint).int64(message.entitlementCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.AppWithEntitlementCountType
 */
export const AppWithEntitlementCountType = new AppWithEntitlementCountType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RequestCatalogSearchServiceEntitlementCountByAppResponse$Type extends MessageType<RequestCatalogSearchServiceEntitlementCountByAppResponse> {
    constructor() {
        super("c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithEntitlementCountType }
        ]);
    }
    create(value?: PartialMessage<RequestCatalogSearchServiceEntitlementCountByAppResponse>): RequestCatalogSearchServiceEntitlementCountByAppResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<RequestCatalogSearchServiceEntitlementCountByAppResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RequestCatalogSearchServiceEntitlementCountByAppResponse): RequestCatalogSearchServiceEntitlementCountByAppResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.requestcatalog.v1.AppWithEntitlementCountType list */ 1:
                    message.list.push(AppWithEntitlementCountType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RequestCatalogSearchServiceEntitlementCountByAppResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.requestcatalog.v1.AppWithEntitlementCountType list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppWithEntitlementCountType.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.requestcatalog.v1.RequestCatalogSearchServiceEntitlementCountByAppResponse
 */
export const RequestCatalogSearchServiceEntitlementCountByAppResponse = new RequestCatalogSearchServiceEntitlementCountByAppResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.requestcatalog.v1.RequestCatalogSearchService
 */
export const RequestCatalogSearchService = new ServiceType("c1.api.requestcatalog.v1.RequestCatalogSearchService", [
    { name: "SearchEntitlements", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/request_catalog/entitlements", group: "Request Catalog" }] }, "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchEntitlementsRequest, O: RequestCatalogSearchServiceSearchEntitlementsResponse },
    { name: "SearchAccessProfileMemberships", options: { "authz.method": { role: "VIEWER" } }, I: AccessProfileMembershipRequest, O: AccessProfileMembershipResponse },
    { name: "SearchAppsWithGrantStatus", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchAppsWithGrantStatusRequest, O: RequestCatalogSearchServiceSearchAppsWithGrantStatusResponse },
    { name: "SearchEntitlementsPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchEntitlementsPerAppRequest, O: RequestCatalogSearchServiceSearchEntitlementsPerAppResponse },
    { name: "SearchCatalogEntitlementsPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppRequest, O: RequestCatalogSearchServiceSearchCatalogEntitlementsPerAppResponse },
    { name: "SearchEntitlementsForUser", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchEntitlementsForUserRequest, O: RequestCatalogSearchServiceSearchEntitlementsForUserResponse },
    { name: "SearchTasksForResources", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchTasksForResourcesRequest, O: RequestCatalogSearchServiceSearchTasksForResourcesResponse },
    { name: "SearchResourceTypesPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchResourceTypesPerAppRequest, O: RequestCatalogSearchServiceSearchResourceTypesPerAppResponse },
    { name: "SearchAccessEntitlementsPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppRequest, O: RequestCatalogSearchServiceSearchAccessEntitlementsPerAppResponse },
    { name: "SearchRequestCatalogs", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequestCatalogsRequest, O: SearchRequestCatalogsResponse },
    { name: "SearchRequestCatalogsWithEnrollmentCounts", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequestCatalogsWithEnrollmentCountsRequest, O: SearchRequestCatalogsWithEnrollmentCountsResponse },
    { name: "SearchAppEntitlementsWithRequestCatalogs", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsWithRequestCatalogsRequest, O: SearchAppEntitlementsWithRequestCatalogsResponse },
    { name: "GetAppEntitlementWithRequestCatalogs", options: { "authz.method": { role: "VIEWER" } }, I: GetAppEntitlementWithRequestCatalogsRequest, O: GetAppEntitlementWithRequestCatalogsResponse },
    { name: "SearchResourcesPerApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchResourcesPerAppRequest, O: RequestCatalogSearchServiceSearchResourcesPerAppResponse },
    { name: "SearchBrowsableApps", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchBrowsableAppsRequest, O: RequestCatalogSearchServiceSearchBrowsableAppsResponse },
    { name: "SearchBrowsableAppResources", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchBrowsableAppResourcesRequest, O: RequestCatalogSearchServiceSearchBrowsableAppResourcesResponse },
    { name: "SearchAppResourcesCount", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchAppResourcesCountRequest, O: RequestCatalogSearchServiceSearchAppResourcesCountResponse },
    { name: "ParseAccessRequestToken", options: { "authz.method": { role: "VIEWER" } }, I: AccessRequestUrlManagerServiceRequest, O: AccessRequestUrlManagerServiceResponse },
    { name: "GenerateAccessRequestToken", options: { "authz.method": { role: "VIEWER" } }, I: AccessRequestUrlManagerServiceGenerateRequest, O: AccessRequestUrlManagerServiceGenerateResponse },
    { name: "SearchAppEntitlementsInCatalog", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsInCatalogRequest, O: SearchAppEntitlementsInCatalogResponse },
    { name: "SearchRemovedUsers", options: { "authz.method": { role: "VIEWER" } }, I: SearchRemovedUsersRequest, O: SearchRemovedUsersResponse },
    { name: "CountUsersLosingMembership", options: { "authz.method": { role: "VIEWER" } }, I: CountUsersLosingMembershipRequest, O: CountUsersLosingMembershipResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementsInCatalogTermsRequest, O: AppEntitlementsInCatalogTermsResponse },
    { name: "SearchRequestCatalogBundles", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequestCatalogBundlesRequest, O: SearchRequestCatalogBundlesResponse },
    { name: "SearchAppResourcesInCatalog", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourcesInCatalogRequest, O: SearchAppResourcesInCatalogResponse },
    { name: "SearchBrowsableAppsInBundle", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRequest, O: RequestCatalogSearchServiceSearchBrowsableAppsInBundleResponse },
    { name: "ListBrowsableAppsInBundle", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceListBrowsableAppsInBundleRequest, O: RequestCatalogSearchServiceListBrowsableAppsInBundleResponse },
    { name: "SearchCatalogEnrollmentsCount", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountRequest, O: RequestCatalogSearchServiceSearchCatalogEnrollmentsCountResponse },
    { name: "SearchBrowsableAppEntitlementsCount", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountRequest, O: RequestCatalogSearchServiceSearchBrowsableAppEntitlementsCountResponse },
    { name: "SearchCatalogEntitlementCountByApp", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceEntitlementCountByAppRequest, O: RequestCatalogSearchServiceEntitlementCountByAppResponse },
    { name: "SearchCatalogAccessEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsRequest, O: RequestCatalogSearchServiceSearchCatalogAccessEntitlementsResponse }
]);
